import React from "react";
import { Link } from "react-router-dom";

const ErrorPage = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center px-6 text-center">
      <p className="text-xs font-light tracking-luxe uppercase text-gold">404</p>
      <h1 className="mt-6 font-display text-4xl font-medium sm:text-5xl">
        This page does not exist.
      </h1>
      <Link
        to="/"
        className="mt-12 border border-white/15 px-8 py-3 text-xs font-light tracking-[0.2em] uppercase text-ivory transition-colors duration-300 hover:border-gold hover:text-gold"
      >
        Return Home
      </Link>
    </div>
  );
};

export default ErrorPage;
